<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('simulation') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <p style="margin-bottom:0">{{ $t('wannaRunSimulation') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="analyseSelection" >
                        {{ $t('analyse') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import AnalysisApi from "../../api/server/analysis";

export default {
    name: "selectionAnalyseModal",
    methods: {
        close() {
            this.$emit("close");
        },
        async analyseSelection() {
            await AnalysisApi.analyseSelection(this.$parent.$route.params.id, this.$parent.$route.params.selectionId);
            this.$emit("close");
            this.$emit("started");
        }
    }
}
</script>